/**
 * Extracts initials from a name string.
 *
 * @param name - The full name to extract initials from
 * @param maxLength - Maximum number of initials to return (default: 2)
 * @returns Uppercase initials (e.g., "John Doe" → "JD", "Alice" → "AL")
 *
 * @example
 * getInitials('John Doe') // 'JD'
 * getInitials('Alice') // 'AL'
 * getInitials('John Paul Doe', 3) // 'JPD'
 */
export function getInitials(name: string, maxLength: number = 2): string {
  if (!name) return ''

  const words = name
    .trim()
    .split(/\s+/)
    .filter(word => word.length > 0)

  if (words.length === 0) return ''

  if (words.length === 1) {
    return words[0]
      .substring(0, maxLength)
      .toUpperCase()
  }

  return words
    .slice(0, maxLength)
    .map(word => word[0])
    .join('')
    .toUpperCase()
}
